import { ReactElement } from "react";
import { sort, SortedField, SortOrder } from "../../../../shared/sort";
import Arrow from "./Arrow";
import styles from "./Sorting.module.scss";

export interface SortingProps
{
    fields: string[];
    sortedField: SortedField;
    onSorting: (field: SortedField) => void;
}

const Sorting = (props: SortingProps): ReactElement =>
{
    const sortedField = props.sortedField;

    const handleSort = (pressedField: string): void =>
    {
        let newSortedField: SortedField = sortedField;

        if (!sortedField || (sortedField && sortedField.caption !== pressedField))
            newSortedField = new SortedField(pressedField, SortOrder.Asc);
        else if (sortedField && sortedField.caption === pressedField)
            newSortedField = new SortedField(pressedField, sort(sortedField.order));

        props.onSorting(newSortedField);
    }

    return (
        <div className={styles.sorting}>
            {props.fields.map((x, i) => (
                <button key={i} className={styles.sortBtn} onClick={() => handleSort(x)}>
                    {x} <Arrow field={x} sortedField={sortedField} />
                </button>
            ))}
        </div>
    );
}

export default Sorting;
